<template>
<div class="chapter">
<div class="inner_page">
<div style="margin-top:0px; margin-left:0px; margin-right:0px; margin-bottom:0px; text-align:center;">&gt;
    <a href="https://theportalist.com/newsletters/?utm_source=PORGOAAAAJ&amp;utm_campaign=9781504075992" target="_blank">
<img alt="image" src="image/port-backad.jpg" style="height:100%; text-align:center;"/>
</a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// port.vue?578cd4d8